import React from "react";

import FormRow from "../../ui/FormRow";
import { useForm } from "react-hook-form";
import { useUpdateUser } from "./useUpdateUser";
import toast from "react-hot-toast";
import { ColorRing } from "react-loader-spinner";

const UpdatePassword = ({ inModal = false }) => {
  const { update, isUpdating } = useUpdateUser();

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
  } = useForm();
  const onSubmit = ({ password }) => {
    update(
      { password },
      {
        onSuccess: () => {
          toast.success("Password updated successfully.");
          reset();
        },
      },
    );
  };
  const onError = (err) => { };

  return (
    <div className={inModal ? "w-full" : "mx-auto max-w-2xl py-8"}>
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        className={inModal ? "grid grid-cols-1 gap-6" : "grid grid-cols-1 gap-8 rounded-xl p-6 shadow-sm dark:shadow-shadowOne"}
      >
        {!inModal && (
          <h2 className="text-center text-lg font-bold capitalize text-sky-500 dark:text-sky-300">
            Modify your password
          </h2>
        )}
        <FormRow
          lable={"password (min 6 chars)"}
          error={errors?.password?.message}
        >
          <input
            type="password"
            placeholder="******"
            disabled={isUpdating}
            className="input-bordered input-info input w-full max-w-xs bg-white font-medium text-zinc-500 disabled:border-none disabled:bg-gray-400 disabled:text-gray-700 dark:bg-zinc-800 dark:disabled:text-gray-500"
            {...register("password", {
              required: "Field is required",
              minLength: {
                value: 6,
                message: "Password should be 6 character long",
              },
            })}
          />
        </FormRow>
        <FormRow
          lable={"confirm password"}
          error={errors?.ConfirmePassword?.message}
        >
          <input
            type="password"
            placeholder="******"
            disabled={isUpdating}
            className="input-bordered input-info input w-full max-w-xs bg-white font-medium text-zinc-500 disabled:border-none disabled:bg-gray-400 disabled:text-gray-700 dark:bg-zinc-800 dark:disabled:text-gray-200"
            {...register("ConfirmePassword", {
              required: "Field is required",
              validate: (value) =>
                value === getValues().password || "Password should be match",
            })}
          />
        </FormRow>

        <div className=" mt-8 flex gap-3 justify-self-end">
          <button
            disabled={isUpdating}
            type="submit"
            className="group relative flex min-w-[8rem] items-center justify-center overflow-hidden rounded-lg bg-gradient-to-r from-primary to-secondary px-6 py-2.5 font-medium text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/30 active:translate-y-0 active:scale-95 disabled:opacity-75"
          >
            <span className="relative z-10 flex items-center gap-2">
              {isUpdating ? (
                <ColorRing
                  height={24}
                  width={24}
                  colors={["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]}
                />
              ) : (
                "Update Password"
              )}
            </span>
            <div className="absolute inset-0 z-0 bg-gradient-to-l from-primary to-secondary opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          </button>
          <button
            type="reset"
            disabled={isUpdating}
            className="flex justify-center rounded-lg border border-stroke px-6 py-2.5 font-medium text-black hover:shadow-1 active:scale-95 disabled:opacity-50 dark:border-strokedark dark:text-white"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdatePassword;
